import { extractReactComponent } from "../../utils/react/extract-react-component-from-svg-file";

import React, { ReactNode } from "react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { useEnvironment } from "../../hooks/use-environment";

const Icons = {
  FullScreenSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/Full Screen.svg").then(
      extractReactComponent,
    ),
  ),
  PauseCircleSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/Pause Circle white.svg").then(
      extractReactComponent,
    ),
  ),
  PlayCircleSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/Play Circle white.svg").then(
      extractReactComponent,
    ),
  ),
  PlayBarSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/Play Black.svg").then(
      extractReactComponent,
    ),
  ),
  PauseBarSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/Pause white.svg").then(
      extractReactComponent,
    ),
  ),
  SoundOnSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/SoundOn.svg").then(
      extractReactComponent,
    ),
  ),
  SoundOffSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/SoundOff.svg").then(
      extractReactComponent,
    ),
  ),
  CaptionsOnSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/CaptionsOn.svg").then(
      extractReactComponent,
    ),
  ),
  CaptionsOffSvgIcon: React.lazy(() =>
    import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/Icon/DKT/Player/CaptionsOff.svg").then(
      extractReactComponent,
    ),
  ),
};

export type VideoIconsT = keyof typeof Icons;

export const VideoIconsRenderer: ReactTFC<
  {
    icon: VideoIconsT;
    fallback?: NonNullable<ReactNode> | null;
  } & React.SVGProps<SVGSVGElement>
> = props => {
  const { icon, fallback, ...rest } = props;
  const env = useEnvironment();

  const fallbackOrNull: NonNullable<ReactNode> | null = fallback || null;

  if (env === "server") {
    return <React.Fragment>{fallbackOrNull}</React.Fragment>;
  }

  const Component = Icons[icon];

  return (
    <React.Suspense fallback={fallbackOrNull}>
      <Component {...(rest as any)} />
    </React.Suspense>
  );
};
